module.exports = __webpack_public_path__ + "img/f-06.f8d50f7e.jpg";